var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepreveLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327,
    height: 160,
    viewBox: "0 0 327 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-308.6 -234.709)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 160,
    transform: "translate(308.6 234.709)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.6 264.709)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.314,297.171V283.914h6.514a6.537,6.537,0,0,1,6.514,6.629,6.61,6.61,0,0,1-6.514,6.629h-6.514Zm17.943-13.143a13.389,13.389,0,0,0-11.314-6.629H356.8v46.4h6.514V303.914h6.514a12.388,12.388,0,0,0,6.514-1.829,13.788,13.788,0,0,0,4.8-4.8,13.024,13.024,0,0,0,1.714-6.629,10.833,10.833,0,0,0-1.6-6.629Z",
    transform: "translate(-268.114 -250.543)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.714,284.029h6.514a6.537,6.537,0,0,1,6.514,6.629,6.61,6.61,0,0,1-6.514,6.629h-6.514Zm0,19.771H287.2l13.829,19.886h8l-14.057-20.114a14.426,14.426,0,0,0,3.886-1.486,13.788,13.788,0,0,0,4.8-4.8,12.929,12.929,0,0,0,0-13.257,13.389,13.389,0,0,0-11.314-6.629H279.2v46.4h6.514Z",
    transform: "translate(-279.2 -250.543)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.914,284.029h16.457V277.4H319.4v46.286h22.971v-6.629H325.914V303.8h13.143v-6.629H325.914Z",
    transform: "translate(-273.457 -250.543)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.429,284.029h16.457V277.4H457.8v46.286h23.086v-6.629H464.429V303.8h13.143v-6.629H464.429Z",
    transform: "translate(-253.686 -250.543)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.629,284.029h16.343V277.4H534v46.286h22.971v-6.629H540.629V303.8h13.029v-6.629H540.629Z",
    transform: "translate(-242.8 -250.543)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.186,306.429,497.671,277.4H490.7l17.486,48.343L525.671,277.4H518.7Z",
    transform: "translate(-248.986 -250.543)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.571,277.443a43.383,43.383,0,0,1,64.686-5.943h-3.314v5.943h13.714V263.614h-5.829v4.114A49.236,49.236,0,0,0,382,273.9l4.571,3.543Z",
    transform: "translate(-264.514 -253.9)",
    fill: "#78bd43",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.586,320.8a43.383,43.383,0,0,1-64.686,5.943h3.314V320.8H381.5v13.829h5.829v-4.114a49.236,49.236,0,0,0,73.829-6.171l-4.571-3.543Z",
    transform: "translate(-264.586 -244.343)",
    fill: "#78bd43",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.9,301.886a34.069,34.069,0,0,0,33.943,34.171,33.466,33.466,0,0,0,15.429-3.771l-18.857-27.2h-1.486v19.886h-6.514v-46.4h13.143a12.388,12.388,0,0,1,6.514,1.829,13.789,13.789,0,0,1,4.8,4.8,12.928,12.928,0,0,1,0,13.257,12.9,12.9,0,0,1-4.8,4.8,14.427,14.427,0,0,1-3.886,1.486L441.643,328.4l.229.229A34.088,34.088,0,1,0,386.9,301.886Z",
    transform: "translate(-263.814 -251.943)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.429,289.729a6.61,6.61,0,0,0-6.514-6.629H412.4v13.257h6.514a6.537,6.537,0,0,0,6.514-6.629",
    transform: "translate(-260.171 -249.729)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.457,279.243h.457a.457.457,0,1,1,0,.914h-.457Zm0,1.486h0l1.143,1.486h.571l-1.029-1.486c.114,0,.229-.114.343-.114l.343-.343a.687.687,0,0,0,.114-.457c0-.229,0-.343-.114-.457l-.343-.343a.687.687,0,0,0-.457-.114H559v3.543h.457Z",
    transform: "translate(-239.229 -250.329)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.214,283.457a2.86,2.86,0,1,1,2.743-2.857,2.807,2.807,0,0,1-2.743,2.857m0-6.057a3.314,3.314,0,1,0,3.314,3.314,3.474,3.474,0,0,0-3.314-3.314",
    transform: "translate(-239.529 -250.543)",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepreveLogo);
export default __webpack_public_path__ + "static/media/RepreveLogo.df57636e025d538bba5a78c518ce2f89.svg";
export { ForwardRef as ReactComponent };